import { createSelector } from 'reselect';
import User from '../../models/User';

const sessionToken = state => state.auth.sessionToken;
const userData = state => state.auth.user;

export const isAuthenticated = createSelector(
  sessionToken,
  token => token !== null && token.length !== 0
);
export const userInfo = createSelector(userData, info => new User(info));



// WEBPACK FOOTER //
// ./src/redux/selectors/auth.js